import { Clock, MapPin, UsersThree, IdentificationBadge, Buildings } from "@phosphor-icons/react";

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleString("es-ES", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  } catch {
    return iso;
  }
}

export default function MeetingCard({ meeting, mine = false, joined = false, onClick }) {
  const occupied = meeting.status !== "open";
  return (
    <button
      type="button"
      onClick={onClick}
      className="zx-card group block w-full p-5 text-left transition-all"
      data-testid={`meeting-card-${meeting.id}`}
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="zx-label">{meeting.type === "2+2" ? "Doble · 2+2" : "Pareja efímera · 1+1"}</p>
          <h3 className="mt-1 font-serif text-2xl tracking-tight text-[#f5f5f5]">
            {mine ? "Tu encuentro" : meeting.organizerNick}
          </h3>
        </div>
        <div className="flex flex-col items-end gap-1">
          {occupied ? (
            <span className="zx-tag">Cerrado</span>
          ) : (
            <span className="zx-tag accent">Abierto</span>
          )}
          {joined && <span className="zx-tag accent">Inscrito</span>}
          {mine && <span className="zx-tag">Mío</span>}
          {meeting.distanceKm != null && (
            <span className="zx-tag">{meeting.distanceKm.toFixed(1)} km</span>
          )}
        </div>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-2 text-sm text-[rgba(255,255,255,0.7)] sm:grid-cols-2">
        <div className="flex items-center gap-2">
          <Clock size={14} weight="thin" />
          <span>{formatDate(meeting.time)}</span>
        </div>
        <div className="flex items-center gap-2">
          <MapPin size={14} weight="thin" />
          <span>
            {mine || joined ? meeting.address : "ubicación aproximada"}
          </span>
        </div>
        {meeting.placeName && (
          <div className="flex items-center gap-2 sm:col-span-2">
            <Buildings size={14} weight="thin" />
            <span data-testid={`meeting-hotel-${meeting.id}`}>
              {meeting.placeName}
              {meeting.placeLocality ? ` · ${meeting.placeLocality}` : ""}
            </span>
          </div>
        )}
        <div className="flex items-center gap-2">
          <UsersThree size={14} weight="thin" />
          <span>
            {meeting.participants?.length || 0} / {meeting.capacity}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <IdentificationBadge size={14} weight="thin" />
          <span>
            {mine || joined ? meeting.identifier : "se revela al confirmar"}
          </span>
        </div>
      </div>

      {(meeting.preferences?.length || meeting.interests?.length) ? (
        <div className="mt-4 flex flex-wrap gap-1.5">
          {(meeting.preferences || []).slice(0, 3).map((t) => (
            <span key={t} className="zx-tag">{t}</span>
          ))}
          {(meeting.interests || []).slice(0, 3).map((t) => (
            <span key={`i-${t}`} className="zx-tag accent">{t}</span>
          ))}
        </div>
      ) : null}
    </button>
  );
}
